export const heightToInches = (height) => {
    const [feet, inches] = height.replace(/[^\d’]/g, "").split("’");
    return parseInt(feet) * 12 + parseInt(inches || "0");
  };
  